// extracted by mini-css-extract-plugin
module.exports = {"container":"SlideButtons_container__Lhkt5","dot":"SlideButtons_dot__sOB72","active":"SlideButtons_active__jc4jd"};